import {
  DenormalizedFormat,
  ImageQualityInfoResponse,
  WatermarkPosition,
  WatermarkSource
} from '@aipb/gulliver/dropbox/model';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'ip-crop',
  templateUrl: './crop.component.html',
  styleUrls: ['./crop.component.scss']
})
export class CropComponent {
  @Input() id: string;
  @Input() resolutionData: ImageQualityInfoResponse;
  @Input() watermarkSources: WatermarkSource[] = [];
  @Input() watermarkPositions: WatermarkPosition[] = [];
  @Input() formats: DenormalizedFormat[] = [];
}
